<template>
    <div>
        <file-upload
            v-if="onCloud"
            :ref="component_id"
            v-model="files"
            @input-file="inputFile"
            :input-id="component_id + 'popover_upload'"
            class="btn"
            style="margin-bottom: 0;"
        >
            <i class="fas fa-upload fa-lg"></i>
        </file-upload>
        <file-upload
            v-else
            :ref="component_id"
            v-model="files"
            @input-file="inputFile"
            @input-filter="inputFilter"
            chunk-enabled
            :accept="acceptQuery"
            :chunk="{
                headers: {Authorization: token},
                action: action,
                minSize: 0,
                maxActive: 3,
                maxRetries: 5,
                startBody: {
                    filename: files.length ? files[0].name : null
                }
             }"
            class="btn"
            style="margin-bottom: 0;">
            <i class="fas fa-upload fa-lg"></i>
        </file-upload>
        <b-progress v-show="files.length ? files[0].active : false"  :value="files.length ? Number(files[0].progress) : 100" variant="secondary" height="0.3em"/>
    </div>
</template>

<script>
import uuidV4 from 'uuid/v4';
import _ from 'lodash';
export default {
    name: 'upload-regular',
    props: {
        acceptQuery: {
            default: () => '*'
        },
        uploadOnCloud: {
            type: Boolean,
            default: () => null
        },
        fileCategory: {
            type: String,
            default: () => 'other'
        }
    },
    data() {
        return {
            component_id: uuidV4(),
            files: [],
            action: null,
            onCloud: false
        };
    },
    methods: {
        inputFile: function(newFile, oldFile) {
            if(this.onCloud){
                let file = _.head(this.files) && _.head(this.files).file;
                if(file){
                    let FR = new FileReader();
                    FR.readAsDataURL(file);
                    FR.onload = event => {
                        return this.axios.post(`/uploadToAws`, {
                            data: event.target.result,
                            type: this.fileCategory,
                            mimeType: _.get(file, 'type'),
                            size: _.get(file, 'size'),
                            originalFileName: _.get(file, 'name'),
                            userIdOverWrite: _.get(this.$store.state.user, 'id')
                        }).then(({data})=>{
                                this.$emit('onupload', {
                                    id: data.id,
                                    fileUrl: data.url,
                                    filename: data.filename,
                                    fileId: data.fileId,
                                    status: 'success',
                                    onCloud: this.onCloud
                                });
                            })
                    };
                }
            }
            else{
                // Upload file immediately
                if (newFile && !newFile.active && !oldFile) {
                    newFile.active = true; // when set true, upload progress will be start.
                }

                // Get response data
                if (newFile && oldFile && !newFile.active && oldFile.active) {
                    this.$emit('onupload', {...newFile.response, onCloud:this.onCloud});
                    if (newFile.xhr) {
                        //  Get the response status code
                        console.log('status', newFile.xhr.status);
                    }
                }
            }
        },

        inputFilter: function(newFile) {
            newFile.blob = '';
            let URL = window.URL || window.webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
            }
        }
    },
    created() {
        this.action = `${this.apiURL}/upload`;
        this.onCloud = this.uploadOnCloud != null ? this.uploadOnCloud : !this.$store.state.isExcludedForAws;
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UploadRegular.vue